export const YES_AND_NO_OPTIONS = [
  { label: 'Yes', value: 'Y' },
  { label: 'No', value: 'N' }
];
